// sessionStorage keys used by the preloader to cache per-user data
// (accounts, transactions, cards, company info, …).
//
// Centralised here — and intentionally free of any imports — so that
// `helpers/utils.ts:logout()` can purge them on logout WITHOUT importing
// `usePreloader.ts` (which imports back from `helpers/utils.ts` and would
// create a circular dependency). `usePreloader.ts` re-uses these same
// constants so there is a single source of truth for the key names.

export const SPARKLINES_CACHE_KEY = 'cache_sparklines'
export const ACCOUNTS_CACHE_KEY = 'cache_accounts'
export const TRANSACTIONS_CACHE_KEY = 'cache_transactions'
export const STATS_TRANSACTIONS_CACHE_KEY = 'cache_stats_transactions'
export const CARDS_CACHE_KEY = 'cache_cards'
export const CARD_TYPES_CACHE_KEY = 'cache_card_types'
export const CURRENCIES_CACHE_KEY = 'cache_currencies'
export const COMPANY_LIST_CACHE_KEY = 'cache_company_list'
export const TARIFF_CACHE_KEY = 'cache_tariff'
export const COMPANY_DATA_CACHE_KEY = 'cache_company_data'

export const PRELOAD_CACHE_KEYS = [
  SPARKLINES_CACHE_KEY,
  ACCOUNTS_CACHE_KEY,
  TRANSACTIONS_CACHE_KEY,
  STATS_TRANSACTIONS_CACHE_KEY,
  CARDS_CACHE_KEY,
  CARD_TYPES_CACHE_KEY,
  CURRENCIES_CACHE_KEY,
  COMPANY_LIST_CACHE_KEY,
  TARIFF_CACHE_KEY,
  COMPANY_DATA_CACHE_KEY,
] as const

/**
 * Remove every preloaded per-user cache entry from sessionStorage.
 *
 * MUST be called on logout / before a new login — otherwise the preloader's
 * `restore*` helpers re-hydrate the previous user's data into the stores,
 * making a freshly logged-in user see the previous user's accounts and
 * transactions. `sessionStorage` survives both a hard page reload and
 * `localStorage.clear()`, so this explicit purge is the only thing that
 * clears it.
 */
export function clearPreloadCacheStorage(): void {
  for (const key of PRELOAD_CACHE_KEYS) {
    try {
      sessionStorage.removeItem(key)
    } catch {
      /* ignore */
    }
  }
}
